module.exports = __webpack_public_path__ + "media/images/icons/flags/PF-0a13772218fc43f8b71553b5699059c3.svg";